export const isAutoRecordCallsEnabled = (user = {}) => {
  const value = user?.auto_record_calls;

  return value !== false && value !== 'false' && value !== 0 && value !== '0';
};
